import { PrimaryButton } from "@/components/Buttons/PrimaryButton";
import { useLocation, useNavigate } from "react-router-dom";

export const SMSUncertifiedRegistration = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const connectSMS = async () => {
    navigate("/sms-verification", { state: location.state });
  };

  return (
    <div className="w-full min-h-screen bg-white">
      <div className="flex flex-col min-h-[calc(100vh-72px)] p-4 sm:px-8">
        <div className="text-lg font-bold leading-normal tracking-tight mt-5">マイページ</div>
        <div className=" mt-[20px] mb-[30px]">
          <div className="mt-[10px] text-black text-sm font-medium tracking-tight">
            あなたの電話番号を連携することで、ポイント獲得や出金、友達招待など多くの機能をスムーズに利用することが可能です。
          </div>
        </div>
        <PrimaryButton content="SMSを連携する" onClick={connectSMS} />
      </div>
    </div>
  );
};
